import styled from "styled-components/macro";
import { BannerFont } from "../../../styles/fonts";

export const BlogDiv = styled.div`
  background-color: white;
  display: block;
  position: relative;
  width: 100%;
  text-align: center;
  margin: 0 auto 0;
`;

export const BlogGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2em;
`;


export const BlogTitle = styled.h1`
    ${BannerFont}
    display: flex;
    flex-direction: column;
    margin-bottom:1em !important;
    & > div > span {
        color: ${(props) => props.theme.colors.primary};
    }
`;
// max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
// export const BlogTitle = styled.h1`
//   ${BannerFont}
//   display: flex;
//   flex-direction: column;
//   & > span {
//     color: ${(props) => props.theme.colors.primary};
//   }
// `;
